import React from 'react';
import TopBar from './TopBar';
import Navbar from './Navbar';
import AboutHero from './AboutHero';
import MissionStatement from './MissionStatement';
import FounderStory from './FounderStory';
import Footer from './Footer';

const AboutPage = () => {
  return (
    <div className="about-page">
      <TopBar />
      <Navbar />
      <AboutHero />
      <MissionStatement />
      <FounderStory />
      <Footer />
    </div>
  );
};

export default AboutPage;
